export function saveAsFile(data: Blob, fileName: string) {
  const url = URL.createObjectURL(data);
  let link: HTMLAnchorElement | undefined;
  try {
    link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
  } finally {
    URL.revokeObjectURL(url);
    link?.remove();
  }
}
